// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_gz","advertCardList_max6":"c-a_gA"};